import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

interface Option {
  value: string;
  label: string;
  active?: boolean;
}

interface FormSelectProps {
  field: any;
  label: string;
  placeholder: string;
  options: Option[];
  disabled?: boolean;
}

const FormSelect: React.FC<FormSelectProps> = ({
  field,
  label,
  placeholder,
  options,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          px: 2,
        })}
        shrink
      >
        {label}
      </InputLabel>
      <Select
        size="small"
        fullWidth
        label={label}
        placeholder={placeholder}
        displayEmpty
        disabled={disabled}
        renderValue={(item) => {
          if (!item.length) return placeholder;
          return options.find((type) => type.value === item)?.label;
        }}
        value={field.value}
        onChange={(e) => field.onChange(e.target.value)}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.active === false}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FormSelect;
